/**
 * Remembers, per user on this device, which organization they last worked in
 * so sign-in can restore it. Best-effort: storage that is missing, blocked or
 * full degrades to "no preference" and never throws.
 */

export function lastOrganizationStorageKey(uid: string): string {
  return `gleanag:lastOrganizationId:${uid}`;
}

export function readLastOrganizationId(uid: string): string | null {
  try {
    return window.localStorage.getItem(lastOrganizationStorageKey(uid));
  } catch {
    return null; // localStorage can throw (e.g. disabled cookies / private mode)
  }
}

export function writeLastOrganizationId(uid: string, orgId: string): void {
  try {
    window.localStorage.setItem(lastOrganizationStorageKey(uid), orgId);
  } catch {
    // ignore — the preference is best-effort
  }
}
